// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-box[data-v-1be86e3a]{border-top:1px solid #dfdfdf!important}.box-number[data-v-1be86e3a]{display:flex;justify-content:center;width:22px}", ""]);
// Exports
module.exports = exports;
